import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import DeviceTypeTableDto from '../dto/DeviceTypeTableDto';

class DeviceTypeTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'deviceTypeTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<DeviceTypeTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, DeviceTypeTableDto)))
				.catch(reject);
		});
	}
}

export default new DeviceTypeTableService();
